// import React, { useState, useEffect, useContext } from "react";
// import { Col, Container, Row } from "react-bootstrap";
// import Slider from "react-slick";
// import "./Blog.css";
// import imgplay from "../../../images/play.png";
// import imgpause from "../../../images/pause.png";
// import imgdownload from "../../../images/download.png";
// import imgvideo from "../../../images/video.png";
// import Modal from "react-bootstrap/Modal";
// // import Button from "react-bootstrap/Button";
// import Button from "@mui/material/Button";
// import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
// import URLstateContext from "../../../provider/CommonContext";
// import { Vortex } from "react-loader-spinner";
// import animation from "../../../images/jm-animation.gif";
// import cureate from "../../../images/Curated_Perspective_banner.jpg";
// import g20 from "../../../images/G20.jpg";
// import macroEconomics from "../../../images/Macro_Economics_chart_book.jpg";
// import {
//   GetMethodData,
//   DecryptAESdata,
// } from "../../../provider/ServiceProvider";

// function Blog() {
//   const BlogSlider = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 0,
//     nextArrow: <BsArrowRight />,
//     prevArrow: <BsArrowLeft />,

//     responsive: [
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           nextArrow: <BsArrowRight />,
//           prevArrow: <BsArrowLeft />,
//         },
//       },
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           nextArrow: <BsArrowRight />,
//           prevArrow: <BsArrowLeft />,
//         },
//       },
//     ],
//   };

//   const [data, setData] = useState("");
//   const { BaseURL } = useContext(URLstateContext);
//   const [srcimg, setSrcimg] = useState(imgplay);
//   const [show1, setShow1] = useState(false);
//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const [modelheading, setModelheading] = useState("");
//   const [embeddedlink, setEmbeddedlink] = useState("");
//   const [loadingshow, setloadingshow] = useState(false);

//   const companyClick = (paramcode, paramname, paramexchange) => {
//     // alert(paramname);
//     window.location.href =
//       "/Blog-Details/" +
//       paramcode +
//       "/" +
//       paramname.replace(/ /g, "-").replace("&", "and").replace("+", "");
//   };

//   useEffect(() => {
//     setloadingshow(true);
//     GetMethodData(BaseURL + "GetBlog").then((data) => {
//       setloadingshow(false);
//       if (data.data != null && data.data.length > 0) {
//         setData(DecryptAESdata(data.data));

//         setloadingshow(false);

//         console.log(
//           DecryptAESdata(data.data),
//           "this is the blog console from the blog component"
//         );
//       }
//     });
//   }, [BaseURL]);

//   const handlePlayVideo = (heading, videolink) => {
//     handleShow(true);
//     setModelheading(heading);
//     setEmbeddedlink(videolink);
//   };
//   const start = (index, audiofile) => {
//     if (document.getElementById("btn" + index).src === imgplay) {
//       document.getElementById("btn" + index).src = imgpause;
//       // document.getElementById("audio" + index).play();
//     } else {
//       document.getElementById("btn" + index).src = imgplay;
//       // document.getElementById("audio" + index).pause();
//     }
//   };
//   return (
//     <>
//       <section className="blog-sc">
//         <Container>
//           <Row>
//             <Col sm={12}>
//               <div className="section-header">
//                 <h2>Insights</h2>
//                 {/* {(data.length === 0) ? <h5 className="errormsgComNew">No Data Available</h5> : ''} */}
//               </div>
//               <div>
//                 {loadingshow ? (
//                   <div className="textcentervertex">
//                     <img src={animation} alt="Loading" />
//                     <div className="model_popup">Please Wait...</div>
//                   </div>
//                 ) : (
//                   <div>
//                     {data.length === 0 ? (
//                       <h5 className="errormsgComNew">No Data Available</h5>
//                     ) : (
//                       <div
//                         className="blog-slider blog-main row d-flex justify-content-center"
//                         style={{ height: "fit-content" }}
//                       >
//                         <Slider {...BlogSlider}>
//                           {/* {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
//                           {documents &&
//                             documents.map((document, index) => (
//                               <div key={index} className="zoom">
//                                 <img
//                                   // src={BaseURL.replace("api/", "") + imgfile}
//                                   src={document.image}
//                                   alt="blog1"
//                                   className="img-fluid"
//                                 />
//                                 <div className="blog-detail">
//                                   <h3>{document.heading}</h3>
//                                   {/* <p>{caption}</p> */}
//                                   {/* <Button
//                                         variant="contained"
//                                         onClick={() => companyClick(srno, heading)} which is draft
//                                       > file edit selection view go run explorer jmmf_React_Repo src components footerlinkdata header logouttabchange fontlincreasedec hamburgermenu header searchpopup home blog download goalplanner homebanner search looking milestone ourfundinner blog file edit selection view go run webpack comiled with 9 warnings co
//                                         Know More
//                                       </Button> */}
//                                   {/* {srno === 9 ? <></> :  */}
//                                   {/* // <div className="know-more-new-blog"> */}
//                                   <a href={document.read}>Read More</a>
//                                   {/* // </div> */}
//                                   {/* } */}
//                                   {/* <div className="know-more-new-blog">
//                                     <a onClick={() => companyClick(srno, heading)}>Know More</a>
//                                   </div> */}
//                                   {/* {filename !== null ? (
//                                     <a
//                                       target="_blank"
//                                       rel="noreferrer" */}
//                                   {/* // href={BaseURL.replace("api/", "") + filename} */}
//                                   {/* href={filename}
//                                     > */}{" "}
//                                   {/* <img
//                                         className="imgborderhome"
//                                         alt="Download"
//                                         src={imgdownload}
//                                       /> */}
//                                   {/* </a>
//                                   ) : (
//                                     ""
//                                   )} */}
//                                   {/* {videofile !== null ? (
//                                     <div className="imgseprater"> | </div>
//                                   ) : (
//                                     ""
//                                   )}
//                                   {videofile !== null ? (
//                                     <img
//                                       onClick={() =>
//                                         handlePlayVideo(heading, videofile)
//                                       }
//                                       className="imgborder"
//                                       alt="Video"
//                                       src={imgvideo}
//                                     />
//                                   ) : (
//                                     ""
//                                   )} */}
//                                   {/* {audiofile !== null ? (
//                                     <div className="imgseprater"> | </div>
//                                   ) : (
//                                     ""
//                                   )} */}
//                                   {/*{audiofile!==null ?  <img id={"btn"+index}  onClick={() => start(index,BaseURL.replace('api/','') + audiofile)}  className='imgborder' src={srcimg} alt='Play'/>   : "" } */}
//                                   {/* {audiofile !== null ? (
//                                     <img
//                                       id={"btn" + index}
//                                       onClick={() =>
//                                         start(
//                                           index,
//                                           BaseURL.replace("api/", "") + audiofile
//                                         )
//                                       }
//                                       className="imgborder"
//                                       src={srcimg}
//                                       alt="Play"
//                                     />
//                                   ) : (
//                                     ""
//                                   )} */}
//                                   {/* {audiofile !== null ? (
//                                     <audio
//                                       id={"audio" + index}
//                                       src={BaseURL.replace("api/", "") + audiofile}
//                                     ></audio>
//                                   ) : (
//                                     ""
//                                   )} */}
//                                 </div>
//                               </div>
//                             ))}
//                         </Slider>
//                         <div className="know-more-fund-button-blog">
//                           <a
//                             href="/Insights/Document-Gallery"
//                             className="btn-ourfund"
//                           >
//                             {" "}
//                             View All{" "}
//                             <i
//                               className="fa fa-arrow-circle-o-right"
//                               aria-hidden="true"
//                             ></i>
//                           </a>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* {loadingshow ? <div className="textcentervertex">
//                      <img src={animation} alt="Loading" />
//                     <div className="model_popup">Please Wait...</div>
//                   </div> : ""
//                   } */}

//               <Modal show={show} onHide={handleClose}>
//                 <Modal.Header closeButton>
//                   <Modal.Title>{modelheading}</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                   <iframe
//                     src={embeddedlink}
//                     title={modelheading}
//                     frameborder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                     allowfullscreen
//                   ></iframe>
//                 </Modal.Body>
//                 <Modal.Footer>
//                   <Button variant="secondary" onClick={handleClose}>
//                     Close
//                   </Button>
//                 </Modal.Footer>
//               </Modal>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// }

// export default Blog;

// const documents = [
//   {
//     image: macroEconomics,
//     heading: "Macro Chart Book",
//     read: "/Insights/DocumentGallery/Macro-Chart-Book-/4",
//   },
//   {
//     image: cureate,
//     heading: "Curated Perspectives",
//     read: "/Insights/DocumentGallery/Curated-Perspectives/9",
//   },
//   {
//     image: g20,
//     heading: "G20 Central Banks: Monetary Policy Stance",
//     read: "/Insights/DocumentGallery/G20-Central-Banks:-Monetary-Policy-Stance-/1",
//   },
// ];

import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import "./Blog.css";
import imgplay from "../../../images/play.png";
import imgpause from "../../../images/pause.png";
import imgdownload from "../../../images/download.png";
import imgvideo from "../../../images/video.png";
import Modal from "react-bootstrap/Modal";
import Button from "@mui/material/Button";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import URLstateContext from "../../../provider/CommonContext";
// import { Vortex } from "react-loader-spinner";
import animation from "../../../images/jm-animation.gif";
// import cureate from "../../../images/Curated_Perspective_banner.jpg";
import g20 from "../../../images/G20.webp";
import macroEconomics from "../../../images/Macro_Economics_chart_book.webp";
import Pharmacontract from "../../../images/JM November Article Thumbnail doc-100.jpg";
import IndiaGrowth from "../../../images/JM Factsheet March 2025 doc-100.webp";
// import GoldAssets from "../../../images/Website Banner May 2025 doc.webp"
import RealState from "../../../images/JM July Website Thumbnails doc.jpg";
import HouseHoldConsumption from "../../../images/JM August Factsheet Articles Youtube Thumbnails doc-100.jpg";
// import GstReformBanner from "../../../images/JM Website Thumbnail Banner doc.webp"
import CryptoCapital from "../../../images/JM August Factsheet Articles doc2x-100.webp";
// import RevivingDemand from "../../../images/JM November Factsheet Articles doc-100.jpg"
// import RevivingDemand from "../../../images/JM-November-Factsheet-Articles-doc-100.png";
import StarIndianConsumer from "../../../images/JM December Factsheet new.png";
// import INRVolatility from "../../../images/JM INR Volatility-100.jpg";
import SensexBannerImage from "../../../images/Artboard 1-100.jpg";
import DecemberFactSheet from "../../../images/JM December Factsheet Cover doc2-100.png";
import WestAisaWar from "../../../images/The War in West Asia Article doc-100.jpg";

import {
  GetMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
// import { HelmetProvider } from "react-helmet-async";
// import { Helmet } from "react-helmet";

/* Comment Just for understanding git */

function Blog() {
  const BlogSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <BsArrowRight />,
    prevArrow: <BsArrowLeft />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [data, setData] = useState([]);
  const { BaseURL } = useContext(URLstateContext);
  const [show, setShow] = useState(false);
  const [modelHeading, setModelHeading] = useState("");
  const [embeddedLink, setEmbeddedLink] = useState("");
  const [loadingShow, setLoadingShow] = useState(false);

  useEffect(() => {
    setLoadingShow(true);
    GetMethodData(`${BaseURL}GetBlog`)
      .then((response) => {
        setLoadingShow(false);
        if (response.data) {
          setData(DecryptAESdata(response.data));
        }
      })
      .catch(() => setLoadingShow(false));
  }, [BaseURL]);

  const handleShowModal = (heading, videoLink) => {
    setModelHeading(heading);
    setEmbeddedLink(videoLink);
    setShow(true);
  };

  return (
    <>
      {/* <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Stay updated with expert insights, market trends, and investment strategies from JM Financial Mutual Fund. Our blog section helps you make informed financial decisions."
          />
          <title>
            Insights | Expert Perspectives on Investing and Market Trends | JM
            Financial Mutual Fund
          </title>
        </Helmet>
      </HelmetProvider> */}

      <section className="blog-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-header">
                <h2>Insights</h2>
              </div>
              <div>
                {loadingShow ? (
                  <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                ) : (
                  <div>
                  {documents.length === 0 ? (
                    <h5 className="errormsgComNew" role="alert">
                      No Data Available
                    </h5>
                  ) : (
                    <div
                      className="blog-slider blog-main row d-flex justify-content-center"
                      style={{ height: "fit-content" }}
                    >
                      <Slider {...BlogSlider}>
                        {documents.map((document, index) => (
                          <div key={index} className="zoom">
                            <img
                              src={document.image}
                              alt={document.heading || "Blog image"}
                              className="img-fluid"
                            />

                            <div className="blog-detail">
                              <h3>{document.heading}</h3>

                              <a
                                href={document.read}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`Read more about ${
                                  document.heading || "this document"
                                }`}
                              >
                                Read More
                              </a>
                            </div>
                          </div>
                        ))}
                      </Slider>

                      <div className="know-more-fund-button-blog">
                        <a
                          href="/Insights/Document-Gallery"
                          className="btn-ourfund"
                          aria-label="View all documents in the Document Gallery"
                        >
                          View All{" "}
                          <i
                            className="fa fa-arrow-circle-o-right"
                            // aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  )}
                </div>
                )}
              </div>

              <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>{modelHeading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <iframe
                    src={embeddedLink}
                    title={modelHeading}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShow(false)}
                    aria-label="blogs close button"
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Blog;

const documents = [
  //   {
  //   image: CryptoCapital,
  //   heading: "Crypto and Capital Markets",
  //   read: "/Insights/DocumentGallery/Curated-Perspectives/9",
  // },

  //  {
  //     image: StarIndianConsumer,
  //     heading: "Do the stars align for the Indian Consumer?",
  //     read: "/Insights/DocumentGallery/Curated-Perspectives/9",
  //   },

  {
    image: WestAisaWar,
    heading: "The War in West Asia",
    read: "https://www.jmfinancialmf.com/CMS/Insights/pdf/The%20War%20in%20West%20Aisa_%20April%202026.pdf",
  },

  // {
  //   image: INRVolatility,
  //   heading: "INR Volatility Hurting Sentiments",
  //   read: "/Insights/DocumentGallery/Curated-Perspectives/9",
  // },

  //   {
  //   image: RevivingDemand,
  //   heading: "Reviving Demand",
  //   read: "/Insights/DocumentGallery/Curated-Perspectives/9",
  // },

  // {
  //   image: HouseHoldConsumption,
  //   heading: "Households Consumption & Savings Dilemma",
  //   read: "/Insights/DocumentGallery/Curated-Perspectives/9",
  // },

  // {
  //   image: RealState,
  //   heading: "Real Estate Sector Industry Overview",
  //   read: "/Insights/DocumentGallery/Curated-Perspectives/9",
  // },
  {
    image: macroEconomics,
    heading: "Macro Chart Book",
    read: "/Insights/DocumentGallery/Macro-Chart-Book-/4",
  },

  {
    image: g20,
    heading: "G20 Central Banks: Monetary Policy Stance",
    read: "/Insights/DocumentGallery/G20-Central-Banks:-Monetary-Policy-Stance-/1",
  },
  // {
  //   image: IndiaGrowth,
  //   heading: "India's Credit Growth is Likely to Pick Up",
  //   read: "/Insights/DocumentGallery/Curated-Perspectives/9",
  //   // read: "/downloads/Factsheet/Factsheet",
  // },
];
